<template>
  <div v-if="value && value.services != null && value.services.length != 0">
    <div class="row mb-3">
      <div class="col-12">
        <em class="fas fa-people-arrows color-primary-2 mr-2" />
        <span>Servicios en Relación de Pago</span>
      </div>
    </div>
    <hr />
    <div v-if="value.services" class="row rounded py-3 mb-3 mt-n2">
      <div
        v-for="(item, index) in value.services"
        :key="`item-index-${index}`"
        class="col-md-3 col-sm-12 mt-3"
      >
        <div class="rounded border border-color--secondary-12 p-3">
          <div class="row">
            <div class="col-8">
              <div class="color-gray-7 font-15">Servicio:</div>
              <div class="color-gray-7 font-weight-bold font-15">
                {{ item.serviceDescription }}
              </div>
            </div>
            <div class="col-4 text-right">
              <action-button
                v-if="!paymentJournal.paymentJournalNumber"
                class="outline-danger pr-1"
                i="fa fa-times-circle font-20 pt-1"
                @click="$emit('on-delete-relation', { ...item })"
              />
            </div>
          </div>
          <div class="row mt-3">
            <div class="col">
              <div class="color-gray-7 font-15">Estudiante:</div>
              <div class="color-gray-7 font-weight-bold font-15">
                {{ item.studentSieId }} - {{ item.studentFullName }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';

export default {
  name: 'PaymentRelationshipList',
  components: {
    ActionButton,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    paymentJournal: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    selected: true,
  }),
  methods: {
    periodDescription(item) {
      return `<div class="color-black font-weight-bold font-16">${item.serviceDescription}-${item.studentFullName}-${item.studentSieId}</div>`;
    },
  },
};
</script>
<style>
.badge-outline-danger {
  color: #f1536e;
  border: 1px solid #f1536e;
}
</style>
